export default {
    DEFAULT: 'DEFAULT',
    CONSTRUCTOR: 'CONSTRUCTOR',
    COMPONENT: 'COMPONENT',
}
